import { render, staticRenderFns } from "./svgIcon.vue?vue&type=template&id=564e1bff&scoped=true"
import script from "./svgIcon.vue?vue&type=script&lang=js"
export * from "./svgIcon.vue?vue&type=script&lang=js"
import style0 from "./svgIcon.vue?vue&type=style&index=0&id=564e1bff&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564e1bff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/uat-inseng/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('564e1bff')) {
      api.createRecord('564e1bff', component.options)
    } else {
      api.reload('564e1bff', component.options)
    }
    module.hot.accept("./svgIcon.vue?vue&type=template&id=564e1bff&scoped=true", function () {
      api.rerender('564e1bff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/svgIcon.vue"
export default component.exports